import { render, staticRenderFns } from "./abstractFormPC.vue?vue&type=template&id=1a8d9fd8&scoped=true"
import script from "./abstractFormPC.vue?vue&type=script&lang=js"
export * from "./abstractFormPC.vue?vue&type=script&lang=js"
import style0 from "./abstractFormPC.vue?vue&type=style&index=0&id=1a8d9fd8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d9fd8",
  null
  
)

export default component.exports